/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../../models/transfer';
import '../../../models/estimated_transfer_event';
import '../../../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "external": {
            "nested": {
              "service": {
                "nested": {
                  "ListEstimatedTransferEventsRequest": {
                    "fields": {
                      "fromAccountId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "toAccountId": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "desiredCreationTime": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "transferType": {
                        "type": ".squareup.sfs.models.TransferType",
                        "id": 4,
                        "rule": "optional"
                      }
                    }
                  },
                  "ListEstimatedTransferEventsResponse": {
                    "fields": {
                      "transferEvents": {
                        "type": ".squareup.sfs.models.EstimatedTransferEvent",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "errors": {
                        "type": ".squareup.connect.v2.resources.Error",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.ListEstimatedTransferEventsRequest && !$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.ListEstimatedTransferEventsResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE ListEstimatedTransferEventsRequest @ squareup/sfs/external/services/transfer/list_estimated_transfer_events.proto at 10:1
 */
export const ListEstimatedTransferEventsRequest = $root.lookupType('squareup.sfs.external.service.ListEstimatedTransferEventsRequest');
fixType(ListEstimatedTransferEventsRequest, {
  fromAccountId: {
    required: true
  },
  toAccountId: {
    required: true
  },
  desiredCreationTime: {
    required: true
  }
});
Builder.createAndAttachToType(ListEstimatedTransferEventsRequest);
/**
 * SOURCE ListEstimatedTransferEventsResponse @ squareup/sfs/external/services/transfer/list_estimated_transfer_events.proto at 35:1
 */
export const ListEstimatedTransferEventsResponse = $root.lookupType('squareup.sfs.external.service.ListEstimatedTransferEventsResponse');
fixType(ListEstimatedTransferEventsResponse, {
  transferEvents: {
    required: true
  }
});
Builder.createAndAttachToType(ListEstimatedTransferEventsResponse);